import axios from "axios";
import { Post } from "../interfaces/post.interface";

interface PagedPost {
  total: number,
  posts: Post[]
}

const formatDate = (date = new Date()) => {
  return new Date(date).toISOString().split('T')[0];
}

const removeNullProperties = (params) => {
  return !params ? null :  Object.entries(params).reduce((acc, [key, value]) => {
    if (value != null && value != '') {
      acc[key] = value;
    }
    return acc;
  }, {});
};

class PostsApi {

  getPosts(type:string = 'blog', currentPage: number = 1, otherSearchParams?): Promise<PagedPost> {
    var apiUrl = `/api/v1/posts?filter[category]=${type}&page=${currentPage}`;    

    return axios.get(apiUrl, {
      params: removeNullProperties(otherSearchParams)
    })
    .then(response => {
      const blogs = response.data.data.map(postData => {
        const post:Post = {
          id: postData.attributes.id,
          title: postData.attributes.title,
          thumbnail: postData.attributes.thumbnail,
          content: postData.attributes.body,
          type: postData.attributes.category || 'blog',
          // author: postData.attributes.author,
          publishedDate: formatDate(postData.attributes.published_at),
        }
        return post;
      })
      return Promise.resolve({posts: blogs, total: response.data.meta.total_count});
    });
  }


  getPost(blogId:number): Promise<Post> {
    const apiUrl = `/api/v1/posts/${blogId}`;

    return axios.get(apiUrl)
    .then(response => {
      const postData = response.data.data.attributes;
      const post:Post = {
        id: response.data.data.id,
        title: postData.title,
        thumbnail: postData.thumbnail,
        content: postData.body,
        type: postData.category || 'blog',
        // author: postData.author,
        publishedDate: formatDate(postData.published_at),
      }
      return Promise.resolve(post);
    });
  }

}

export default PostsApi;